<template>
  <div class="content-container">
    <search-comp @onSearch="attachData" @onReset="onReset">
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="das-form-row">
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Khách sạn</div>
                <div class="child-w-80">
                  <el-select
                    v-model="searchParams.hotelId"
                    multiple
                    collapse-tags
                  >
                    <el-option
                      v-for="(hotel, index) in hotelList"
                      :key="index"
                      :value="hotel.id"
                      :label="hotel.name"
                    ></el-option>
                  </el-select>
                </div>
              </div>
            </div>

            <div class="das-form-col col-3">
              <div class="das-form-input">
                <!-- <div class="label">Nguồn</div>
                <div class="child-w-80">
                  <select-with-search-table
                    style="width: 100%"
                    :rows="sourceOptions"
                    :columns="columnsSource"
                    index-field="id"
                    :dropdown-width="400"
                    :selected-index-field-value="searchParams.sourceId"
                    :value="searchParams.sourceId"
                    @selectionChanged="onSelectRowSource"
                  >
                    <template v-slot:value="{ selectedValue: selectedData }">
                      {{ selectedData?.code }}
                    </template>
                  </select-with-search-table>
                </div> -->
                <div class="label">Nhóm nguồn</div>
                <select-with-search-table
                  style="width: 100%"
                  :rows="sourceGroupOptions"
                  :columns="columnsGroup"
                  :value="searchParams.sourceGroupId"
                  :selected-index-field-value="searchParams.sourceGroupId"
                  index-field="id"
                  @selectionChanged="onSelectRowOption"
                >
                  <template v-slot:value="{ selectedValue: selectedData }">
                    {{ selectedData?.code }}
                  </template>
                </select-with-search-table>
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">{{ $t('field.roomLevel') }}</div>
                <el-select
                  v-model="searchParams.roomLevelId"
                  filterable
                  clearable
                >
                  <el-option
                    v-for="item in roomLevelList"
                    :key="item.id"
                    :label="`(${item.code}) - ${item.name}`"
                    :value="item.id"
                  />
                </el-select>
              </div>
            </div>
          </div>
          <div class="das-form-row">
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Từ ngày</div>
                <div class="child-w-80">
                  <!-- :date-data="agentItem.representative_card_date" -->
                  <!-- v-model="agentItem.representative_card_date" -->
                  <!-- @changeCalendar="onChangeDate2" -->
                  <CalendarRange
                    v-model="datetimeRange"
                    style="display: block; width: 500px"
                    mode="date"
                    @input="setDateRange"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </search-comp>
    <div class="content-box">
      <div class="section-box outline">
        <div class="das-form-container">
          <div class="das-form-title-container justify-space-between">
            <div class="das-form-title">
              <span class="main-title"
                >Báo cáo doanh thu đặt phòng theo hạng phòng</span
              >
            </div>
            <div class="button-containers-title">
              <InfoBtn @click="dialogFormVisible = true" />
              <el-dropdown trigger="click" @command="handleCommand">
                <button class="btn medium primary outline download-button">
                  <i class="el-icon-download"></i>
                </button>
                <el-dropdown-menu>
                  <el-dropdown-item command="pdf">Xuất PDF</el-dropdown-item>
                  <el-dropdown-item command="excel"
                    >Xuất Excel</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
              <!-- <button class="btn primary small">Xuất Excel</button> -->
            </div>
            <!-- <button class="btn medium primary outline">Thêm</button> -->
          </div>
          <hr />
          <div v-loading="loading" class="grid-scroll mt-10">
            <GridVx
              ref="agGrid"
              :columns="columns"
              :rows="rows"
              class="agGrid"
              :header-height-setter="headerHeightSetter"
              :is-header-height-setter="true"
              :default-col-def="defaultColDef"
              :auto-select-first-row="false"
              :auto-size-cell="true"
              row-selection="false"
            />
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      title="Chú thích"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      width="500px"
    >
      <div class="das-form-container">
        <div class="das-form-group">
          <ul class="annotate-container">
            <li>Hạng phòng: Hiển thị hạng phòng của đặt phòng</li>
            <li>
              Số lượng phòng: Hiển thị số lượng phòng được đặt của hạng phòng
              trong từng ngày thuộc khoảng ngày tìm kiếm
            </li>
            <li>Ngày đến: hiển thị ngày đến trong khoảng ngày được tìm kiếm</li>
            <li>
              Doanh thu thực: hiển thị doanh thu thực bằng số lượng phòng *giá
              phòng - giảm giá, ví dụ giảm giá 10%, giá phòng Sup: 1,000,000.
              Suite: 1,000,000.
            </li>
            <li>Công suất: bằng số lượng/ tổng số phòng *100</li>
            <li>
              Nhóm nguồn: hiển thị nguồn và danh sách số lượng đặt phòng theo
              từng ngày của nhóm nguồn
            </li>
            <li>
              Tổng: hiển thị tổng số lượng phòng của từng hạng phòng theo từng
              ngày
            </li>
          </ul>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button class="btn primary small" @click="dialogFormVisible = false">
            {{ $t('button.cancel') }}
          </button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import { getSourceApi } from '@/api/Statistics/source'
import SingleCalendar from '@/components/ui/SingleCalendar.vue'
import SelectWithSearchTable from '@/components/inputs/SelectWithSearchTable.vue'
import { getAllHotel } from '@/api/hotel'
import { getListRoomLevelApi } from '@/api/Room/roomLevel'
import { getSourceGroupApi } from '@/api/Statistics/sourceGroup'
import {
  getListRevenueBookingReport,
  getListRevenueBookingReportExcel
} from '@/api/report_service/revenueReportbyRoomLevel'
import InfoBtn from './components/InfoBtn.vue'
import CalendarRange from '@/components/CalendarSelect/CalendarRange.vue'

export default {
  components: {
    SingleCalendar,
    SelectWithSearchTable,
    InfoBtn,
    CalendarRange
  },
  data() {
    return {
      defaultColDef: {
        flex: 1,
        // resizable: true,
        // sortable: true,
        suppressMovable: true,
        // wrapText: true,
        // autoHeight: true,
        headerComponentParams: {
          template:
            '<div class="ag-cell-label-container" role="presentation">' +
            '  <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>' +
            '  <div ref="eLabel" class="ag-header-cell-label" role="presentation">' +
            // '    <span ref="eSortOrder" class="ag-header-icon ag-sort-order"></span>' +
            // '    <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon"></span>' +
            // '    <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon"></span>' +
            // '    <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon"></span>' +
            '    <span ref="eText" class="ag-header-cell-text" role="columnheader" style="white-space: normal;"></span>' +
            // '    <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>' +
            '  </div>' +
            '</div>'
        }
      },
      defaultDatetimeRange: {
        start: this.$moment().format('YYYY-MM-DD'),
        end: this.$moment().format('YYYY-MM-DD')
      },
      datetimeRange: {
        start: this.$moment().format('YYYY-MM-DD'),
        end: this.$moment().format('YYYY-MM-DD')
      },
      dialogFormVisible: false,
      hotelList: [],
      roomLevelList: [],
      loading: false,
      searchParams: {
        dateFrom: this.$moment().format('YYYY-MM-DD'),
        dateTo: this.$moment().format('YYYY-MM-DD'),
        hotelId: [],
        // sourceId: ''
        sourceGroupId: null,
        roomLevelId: null
      },
      defaultSearchParams: {
        hotelId: [],
        // sourceId: '',
        sourceGroupId: null,
        roomLevelId: null,
        dateFrom: this.$moment().format('YYYY-MM-DD'),
        dateTo: this.$moment().format('YYYY-MM-DD')
      },
      sourceOptions: [],
      columnsSource: [
        {
          headerName: 'Mã nguồn',
          field: 'code',
          minWidth: 120,
          maxWidth: 150
        },
        {
          headerName: 'Mô tả',
          field: 'desc',
          flex: 1
        }
      ],
      sourceGroupOptions: [],
      columnsGroup: [
        {
          headerName: 'Mã nhóm',
          field: 'code',
          minWidth: 150,
          maxWidth: 180,
          sortable: false
        },
        {
          headerName: 'Mô tả',
          field: 'desc',
          flex: 1,
          sortable: false
          // cellRenderer: 'CellRenderTextInput',
        }
      ],
      columns: [
        // {
        //   headerName: '',
        //   field: 'index',
        //   minWidth: 60,
        //   maxWidth: 60,
        //   headerCheckboxSelection: true,
        //   headerCheckboxSelectionFilteredOnly: true,
        //   checkboxSelection: true,
        //   resizable: false
        //   // cellStyle: {'padding-left': '12px'}
        // },
        {
          headerName: this.$t('grid.column.roomLevel'),
          field: 'room_level_nm',
          // cellClass: "grid-cell-centered",
          sortable: false,
          minWidth: 150
        },
        {
          headerName: this.$t('grid.column.numRoom'),
          field: 'num_of_room',
          // cellClass: "grid-cell-centered",
          // width: 100,
          sortable: false,
          minWidth: 100
        },
        {
          headerName: this.$t('grid.column.allRoom'),
          field: 'total_room',
          // cellClass: "grid-cell-centered",
          // width: 100,
          sortable: false,
          minWidth: 100
        },
        {
          headerName: this.$t('grid.column.arrivalDate'),
          field: 'arrive_date',
          // cellRenderer: 'CellRenderTextInput',
          minWidth: 240,
          maxWidth: 260,

          sortable: false
          // cellClass: "grid-cell-centered",
        },
        {
          headerName: this.$t('grid.column.realRevenue'),
          field: 'real_revenue',
          // cellRenderer: 'CellRenderTextInput',
          sortable: false,
          valueGetter: params => {
            if (params.data.real_revenue) {
              return Number(params.data.real_revenue).toLocaleString('en')
            } else {
              return null
            }
          },
          minWidth: 150
          // cellClass: "grid-cell-centered",
        },
        {
          headerName: this.$t('grid.column.capacity'),
          field: 'capacity',
          // cellRenderer: 'CellRenderTextInput',
          sortable: false,
          valueGetter: params => {
            return `${
              Math.round(
                (params.data.num_of_room / params.data.total_room) * 10000
              ) / 100
            } %`
          },
          minWidth: 100
          // cellClass: "grid-cell-centered",
        }
      ],
      rows: []
    }
  },
  created() {
    // this.getListSource()
    this.getListHotel()
    this.getSourceGroup()
    this.getRoomLevelOptions()
  },
  mounted() {
    this.attachData()
  },
  methods: {
    handleCommand(cmmd) {
      if (cmmd == 'pdf') {
        // let worker = html2pdf()
        // let element = document.getElementById('table-print')
        // worker.from(element).toPdf().save()
      }
      if (cmmd == 'excel') {
        getListRevenueBookingReportExcel(this.searchParams).then(res => {
          if (res) {
            const date = this.$moment().format('DD-MM-YYYY')
            const href = URL.createObjectURL(res)
            // create "a" HTML element with href to file & click
            const link = document.createElement('a')
            link.href = href
            link.setAttribute(
              'download',
              'doanh_thu_dat_phong_theo_hang_phong_report_' + date + '.xlsx'
              // res.headers['content-disposition'].split('filename=')[1],
            ) // or any other extension
            document.body.appendChild(link)
            link.click()
            // clean up "a" element & remove ObjectURL
            document.body.removeChild(link)
            URL.revokeObjectURL(href)
          } else {
            throw new Error(res)
          }
        })
      }
    },
    setDateRange(range) {
      this.searchParams.dateFrom = range.start
      this.searchParams.dateTo = range.end
    },
    headerHeightGetter() {
      var columnHeaderTexts = [
        ...document.querySelectorAll('.ag-header-cell-text')
      ]
      var clientHeights = columnHeaderTexts.map(
        headerText => headerText.clientHeight
      )
      var tallestHeaderTextHeight = Math.max(...clientHeights)

      return tallestHeaderTextHeight
    },
    headerHeightSetter() {
      var padding = 25
      var height = this.headerHeightGetter() + padding
      this.$refs.agGrid.gridApi.setHeaderHeight(height)
      this.$refs.agGrid.gridApi.resetRowHeights()
    },
    onSelectRowOption(val) {
      this.searchParams.sourceGroupId = val.id
    },
    async getSourceGroup() {
      let data = await getSourceGroupApi({ isActive: 1 })
      this.sourceGroupOptions = data.data
    },
    async getListSource() {
      const data = await getSourceApi({ isActive: 1 })
      this.sourceOptions = data.data
    },
    onSelectRowSource(val) {
      this.searchParams.sourceId = val?.id
    },
    async getListHotel() {
      const data = await getAllHotel()
      this.hotelList = data.data
    },
    async getRoomLevelOptions() {
      const data = await getListRoomLevelApi()
      this.roomLevelList = data?.data || []
      // await getRoom()
    },
    async attachData() {
      try {
        this.loading = true

        const data = await getListRevenueBookingReport(this.searchParams)
        this.loading = false
        // data?.data.forEach(element => {
        //   this.rows = [
        //     ...this.rows,
        //     element,
        //     {
        //       name: ['Ghi chú: ', element.note].join(' '),
        //       isFullWidthRow: true
        //     }
        //   ]
        // })

        // this.rows = data.data
        this.rows = []
        data?.data.forEach(data => {
          this.rows = [
            ...this.rows,
            {
              name: [
                'Nhóm nguồn: ',
                data.source_group_nm
                // '. Nguồn: ',
                // data.source_nm
              ].join(''),
              isFullWidthRow: true
            },
            ...data.detail
          ]
        })
      } catch (error) {
        this.$message({
          type: 'error',
          message: this.$t(error)
        })
      } finally {
        this.loading = false
      }
    },
    onReset() {
      this.searchParams = { ...this.defaultSearchParams }
      this.datetimeRange = { ...this.defaultDatetimeRange }
      this.attachData()
    }
  }
}
</script>

<style lang="scss">
.button-containers-title {
  display: flex;
  /* margin-top: 20px; */
  justify-content: flex-end;
  align-items: flex-end;
  gap: 10px;
  .download-button {
    padding: 10px 10px;
  }
}
</style>
